@if (passedPositions) {
  <div class="p-4 history-scrub-bar">
    <div class="controls" (click)="togglePlay()">
      @if (isRestart) {
        <i class="fas fa-undo"></i>
      }
      @if (!isRestart && !isPlaying) {
        <i class="fas fa-play"></i>
      }
      @if (!isRestart && isPlaying) {
        <i class="fas fa-pause"></i>
      }
    </div>
    <div class="position-relative slider">
      <mat-slider
        [min]="min"
        [max]="max"
        [step]="step"
        discrete
        [displayWith]="formatLabel" #ngSlider><input matSliderThumb [value]="value" (input)="valueUpdated(ngSliderThumb.value)" #ngSliderThumb="matSliderThumb" />
      </mat-slider>
      <p class="slider-limit-value firstValue">{{firstValue}}</p>
      <p class="slider-limit-value endValue">{{lastValue}}</p>
    </div>
  </div>
}